import { config } from "../../config";
import { Book } from "./data-types";

type SearchResult = {
    data?: Array<Book>
    error?: string
}

export const searchBooks = async (query: string, offset: number, limit: number, token?: string): Promise<SearchResult> => {
    try {
        const authHeaders: {[key: string]: string} = {}
        if (token) {
            authHeaders['token'] = token!
        }

        const res = await fetch(`${config.api.urlV1}/book/search/?query=${query}&offset=${offset}&limit=${limit}`, {
            method: 'GET',
            headers: {
                ...authHeaders,
                'Content-type': 'application/json',
            },
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.error?.title
            }
        }

        const body: Array<Book> = await res.json()

        return {
            data: body,
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}
